/** Пустой id — микрофон по умолчанию в системе/браузере. */
export const DEFAULT_MIC_DEVICE_ID = "";

/**
 * Список входов audio. Подписи устройств видны после разрешения на микрофон.
 * @returns {Promise<Array<{ deviceId: string, label: string }>>}
 */
export async function listAudioInputDevices() {
  if (!navigator.mediaDevices?.enumerateDevices) {
    return [];
  }
  const devices = await navigator.mediaDevices.enumerateDevices();
  let index = 0;
  return devices
    .filter(device => device.kind === "audioinput")
    .map(device => {
      index += 1;
      return {
        deviceId: device.deviceId,
        label: device.label || `Microphone ${index}`
      };
    });
}

/**
 * Ограничения getUserMedia: выбранный микрофон или системный по умолчанию.
 * @param {string} deviceId
 */
export function microphoneConstraints(deviceId) {
  const audio = {
    echoCancellation: true,
    noiseSuppression: true,
    autoGainControl: true
  };
  if (deviceId) {
    audio.deviceId = { exact: deviceId };
  }
  return { video: false, audio };
}
